/* Wellbrick — MEN/WOMEN toggle → show the correct SHOP ALL button
   How it works:
   1) Finds the "Shop By Category" section by its heading text.
   2) Locates the MEN/WOMEN pills *inside that section only*.
   3) Shows either the MEN or WOMEN "SHOP ALL" button.
   4) Watches for active-state changes (class/aria) and click events.
*/
(function () {
  const log = (...a) => console.log('[WB TOGGLE]', ...a);
  const warn = (...a) => console.warn('[WB TOGGLE]', ...a);
  const norm = (s) => (s || '').replace(/\s+/g, ' ').trim().toLowerCase();

  // ---- Optional: expose a quick test in Console ----
  window.wbTest = () => log('wb-toggle.js loaded ✅');

  document.addEventListener('DOMContentLoaded', () => {
    log('DOMContentLoaded');

    // --- 1) Find the "Shop By Category" section by heading text ---
    const headings = Array.from(document.querySelectorAll('h1, h2, h3'));
    const shopByHeading = headings.find(h => norm(h.textContent) === 'shop by category');

    if (!shopByHeading) {
      return warn('Could not find "Shop By Category" heading. Update the text or add custom classes and selectors.');
    }

    const shopBySection =
      shopByHeading.closest('.shopify-section') ||
      shopByHeading.closest('section') ||
      document;

    log('shopBySection:', shopBySection);

    // --- 2) Find MEN/WOMEN pills inside this section only ---
    // If you can add classes in your theme, do it and these will be used:
    let menToggle   = shopBySection.querySelector('.wb-men-toggle');
    let womenToggle = shopBySection.querySelector('.wb-women-toggle');

    // Fallback: try to detect by text on common tab/button/link elements
    if (!menToggle || !womenToggle) {
      const candidates = Array.from(
        shopBySection.querySelectorAll(
          'button, a, [role="tab"], .tab, .tabs__button, .segmented-control button, .segmented-control a'
        )
      );
      menToggle   = menToggle   || candidates.find(el => norm(el.textContent) === 'men');
      womenToggle = womenToggle || candidates.find(el => norm(el.textContent) === 'women');
    }

    log('menToggle:', menToggle);
    log('womenToggle:', womenToggle);
    if (!menToggle || !womenToggle) {
      return warn('MEN/WOMEN pills not found in the section. Add classes .wb-men-toggle and .wb-women-toggle, or adjust selectors.');
    }

    // --- 3) Get the two CTA buttons (anywhere on page) ---
    // Best: add these classes to your two buttons in the Buttons block.
    let mensBtn   = document.querySelector('.shop-all-mens');
    let womensBtn = document.querySelector('.shop-all-womens');

    // Fallback by text if classes aren’t present:
    if (!mensBtn || !womensBtn) {
      const allBtns = Array.from(document.querySelectorAll('a.button, button.button, .button, .btn'));
      mensBtn   = mensBtn   || allBtns.find(el => norm(el.textContent).includes('shop all men'));
      womensBtn = womensBtn || allBtns.find(el => norm(el.textContent).includes('shop all women'));
    }

    // Fallback #2: grab next section after Shop By Category that has at least 2 buttons
    if (!mensBtn || !womensBtn) {
      let next = shopBySection.nextElementSibling;
      while (next && !(next.querySelectorAll('.button, .btn').length >= 2)) {
        next = next.nextElementSibling;
      }
      if (next) {
        const btns = next.querySelectorAll('.button, .btn');
        mensBtn   = mensBtn   || btns[0];
        womensBtn = womensBtn || btns[1];
      }
    }

    log('mensBtn:', mensBtn);
    log('womensBtn:', womensBtn);
    if (!mensBtn || !womensBtn) {
      return warn('Could not find both SHOP ALL buttons. Add .shop-all-mens and .shop-all-womens classes or tweak text matching.');
    }

    // --- 4) Show/hide helpers ---
    const show = (which) => {
      log('show()', which);
      if (which === 'women') {
        mensBtn.style.display = 'none';
        womensBtn.style.display = '';
      } else {
        mensBtn.style.display = '';
        womensBtn.style.display = 'none';
      }
    };

    const looksActive = (el) =>
      el.classList.contains('active') ||
      el.classList.contains('is-active') ||
      el.classList.contains('selected') ||
      el.getAttribute('aria-selected') === 'true' ||
      el.getAttribute('aria-pressed') === 'true';

    // --- 5) Initial state (default to MEN if unclear) ---
    const initial = looksActive(womenToggle) ? 'women' : (looksActive(menToggle) ? 'men' : 'men');
    show(initial);

    // --- 6) Wire up clicks ---
    menToggle.addEventListener('click',  () => show('men'));
    womenToggle.addEventListener('click', () => show('women'));

    // --- 7) Watch for class/aria changes (if theme switches state without clicks) ---
    const mo = new MutationObserver(() => {
      if (looksActive(womenToggle)) return show('women');
      if (looksActive(menToggle))   return show('men');
    });
    [menToggle, womenToggle].forEach(el => {
      mo.observe(el, { attributes: true, attributeFilter: ['class', 'aria-selected', 'aria-pressed'] });
    });

    log('WB toggle wired up ✅');
  });
})();